var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useState, useCallback } from "react";
import { Edge3D } from "./edge-3d";
import { EdgeOverlay } from "./edge-overlay";
import { TubeType } from "store/types";
import { round } from "utility/number";
import { useAppSelector, useAppDispatch, selectors, actions } from "store";
import { Skip } from "3d/tube-rendering";
export var Edge = function (_a) {
    var _b;
    var app = _a.app, edge = _a.edge, modelAssets = _a.modelAssets, materialAssets = _a.materialAssets, movingNodeIds = _a.movingNodeIds, hoverId = _a.hoverId;
    var _c = __read(useState(0), 2), curveLength = _c[0], setCurveLength = _c[1];
    var _d = __read(useState(null), 2), middlePosition = _d[0], setMiddlePosition = _d[1];
    var useDoubleCompressedAirTubes = useAppSelector(selectors.selectUseDoubleCompressedAirTubes);
    var draggedAttachmentId = useAppSelector(selectors.selectDraggedAttachmentId);
    var hoveredAttachmentId = useAppSelector(selectors.selectHoveredAttachmentId);
    var dispatch = useAppDispatch();
    var isDoubleTube = edge.tubeType === TubeType.COMPRESSED_AIR && useDoubleCompressedAirTubes;
    var _e = useAppSelector(selectors.selectEdgeConnections(edge.id)), fromNode = _e.fromNode, toNode = _e.toNode;
    var selectedEdge = useAppSelector(selectors.selectSelectedEdge);
    var isSelected = (selectedEdge === null || selectedEdge === void 0 ? void 0 : selectedEdge.id) === edge.id;
    var isMultiSelecting = useAppSelector(selectors.selectIsMultiSelecting);
    // if we are moving/dragging an edge to an attachment, hide the dragged edge
    // and the edge that is currently attached to that attachment
    var edgeMightBeRemoved = draggedAttachmentId &&
        hoveredAttachmentId &&
        [hoveredAttachmentId, draggedAttachmentId].some(function (id) {
            return [edge.fromAttachmentId, edge.toAttachmentId].includes(id);
        });
    var hideEdge = (_b = (edgeMightBeRemoved ||
        (movingNodeIds === null || movingNodeIds === void 0 ? void 0 : movingNodeIds.some(function (id) { return id === (fromNode === null || fromNode === void 0 ? void 0 : fromNode.id) || id === (toNode === null || toNode === void 0 ? void 0 : toNode.id); })))) !== null && _b !== void 0 ? _b : false;
    // skip drawing the start or end part when dragging an edge
    var skip = draggedAttachmentId === edge.fromAttachmentId
        ? Skip.END
        : draggedAttachmentId === edge.toAttachmentId
            ? Skip.START
            : Skip.NONE;
    var onMiddlePositionChange = useCallback(function (pos) {
        setMiddlePosition(pos);
    }, []);
    var onCurveLengthChange = useCallback(function (length) {
        setCurveLength(length);
    }, []);
    useEffect(function () {
        var length = round(curveLength);
        /* A non-positive length means the tube hasn't been measured yet — the
         * endpoint entities aren't resolved/positioned on this render (common right
         * after an undo/redo remount, before the 3D scene catches up). Persisting it
         * would overwrite the real length with 0 and make the calculation request
         * invalid (the calc API rejects zero-length tubes), so keep the last good
         * value until a real measurement comes in. */
        if (!edge.lengthLocked && length > 0) {
            dispatch(actions.setEdgeLength({
                edgeIds: [edge.id],
                length: length,
            }));
        }
    }, [curveLength, edge.id, dispatch, edge.lengthLocked]);
    return (_jsxs(_Fragment, { children: [_jsx(Edge3D, { app: app, modelAssets: modelAssets, materialAssets: materialAssets, edge: edge, hideEdge: hideEdge, isDoubleTube: isDoubleTube, skip: skip, hoverId: hoverId, onMiddlePositionChange: onMiddlePositionChange, onCurveLengthChange: onCurveLengthChange }), _jsx(EdgeOverlay, { app: app, edge: edge, middlePosition: middlePosition, isSelected: isSelected, isMultiSelecting: isMultiSelecting, hideEdge: hideEdge, isDoubleTube: isDoubleTube, onCurveLengthChange: onCurveLengthChange })] }));
};
